import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { getData } from "./data"
import Table from "./Table"
import { getAllBonuses } from "store/Bonuses/actions"
import { useSelector, useDispatch } from "react-redux"
import {sitename} from "../../../constants/constants";

const Bonuses = props => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllBonuses())
  }, [])
  const Bonuses = useSelector(state => state.bonuses.Index ?? [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Bonuses" />
        </Container>
        <Table data={getData(Bonuses)} />
      </div>
    </React.Fragment>
  )
}

export default withRouter(Bonuses)
